import $ from "jquery";

const utilsPostVideoPlayer = () => {
    const init = () => {
        execute();
    };
    
    const execute = () => {
        $(document).ready(function ($) {
            $('.video-thumbnail').on('click', function () {
                const videoUrl = $(this).data('video-url');
                const videoType = $(this).data('video-type') || 'video/mp4';
                let videoPlayer;

                if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
                    const videoId = videoUrl.split('v=')[1] || videoUrl.split('/').pop();
                    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
                    videoPlayer = $('<iframe>', {
                        width: 1080,
                        height: 570,
                        src: embedUrl,
                        frameborder: 0,
                        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
                        allowfullscreen: true
                    });
                } else {
                    videoPlayer = $('<video>', {
                        width: 1080,
                        height: 570,
                        controls: true
                    });
                    const source = $('<source>', {
                        src: videoUrl,
                        type: videoType
                    });
                    videoPlayer.append(source);
                }

                $(this).off('click').empty().append(videoPlayer);
                if (videoPlayer[0].tagName === 'VIDEO') {
                    videoPlayer[0].play();
                }
            });
        });
    };

    init();
};

try {
    utilsPostVideoPlayer();
} catch (error) {
    console.error("utilsPostVideoPlayer", error);
}